import { useEffect, useRef } from 'react';

const LOGO_VIDEO_SRC = '/videos/hxd-logo-brief.mp4';
const PLAY_DELAY_MS = 1000;

const logoClassName = 'block w-full max-w-[500px] h-auto mx-auto';

/**
 * Brief masthead logo: motion plays on every brief view after a short delay.
 */
export default function BriefMastheadLogo() {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.currentTime = 0;
    video.pause();

    const timer = window.setTimeout(() => {
      video.play().catch(() => {});
    }, PLAY_DELAY_MS);

    return () => window.clearTimeout(timer);
  }, []);

  return (
    <video
      ref={videoRef}
      src={LOGO_VIDEO_SRC}
      className={logoClassName}
      width={500}
      height={167}
      muted
      playsInline
      preload="auto"
      disablePictureInPicture
      controls={false}
      controlsList="nodownload nofullscreen noremoteplayback"
      onContextMenu={(e) => e.preventDefault()}
      tabIndex={-1}
      aria-label="Hangar X Daily"
    />
  );
}
